export default __webpack_public_path__ + "static/media/cp_geo_bg.de05ca98.svg";